// extracted by mini-css-extract-plugin
module.exports = {"floatingButton":"whatsapp-button_floatingButton__rVT_E","image":"whatsapp-button_image___iVah"};